require('../../modules/es6.object.set-prototype-of');
module.exports = require('../../modules/_core').Object.setPrototypeOf;



// WEBPACK FOOTER //
// ../~/core-js/library/fn/object/set-prototype-of.js